import NavButton from "../Nav.button/Nav.button";
import {gsap} from "gsap";
import NavigationBackButton from "../Navigation.li.backButton";
import Router from "../../App/Router";

const NavigationMain = {
    el: {},
    levels: [
        {number: 0, id: null, li: null, dropdown: null, theme: ''}
    ],
    lastLevel: null,
    container: null,
    menuItems: null,
    width: '',

    init: function () {
        this.el = $('[component="Navigation"]');
        if (!this.el.length) return;

        this.menu = this.el.find('[block="menu"]');
        this.logo = this.el.find('[block="logo"]');
        this.container = this.el.find('[module="structure"][method="renderMenu"][dropdown="click"]');
        this.folders = this.container.find('li.hasChildren');
        this.anchors = this.container.find('li').not('.hasChildren').find('a');
        this.lastLevel = this.levels[0];
        this.icons = this.el.find('footer .socials a');
        this.prepare();
        this.resize();
        this.bind();

        NavButton.init($('[component="Header"]'));
    },

    prepare() {
        this.folders.each((i, el) => {
            const caption = $(el).find('> a').text();
            const dropdown = $(el).find('> .dropdown');
            const level = dropdown.attr('level');
            NavigationBackButton.render(level, caption).prependTo(dropdown);
        })
    },

    bind() {
        this.folders.find(' > a').unbind('click').click((evt) => {
            evt.preventDefault();
        })

        this.folders.click((evt) => {
            evt.stopPropagation();
            this.click($(evt.currentTarget));
        })


        this.anchors.unbind('click').click((evt) => {
            console.log('click')
            // evt.preventDefault();
            // const el = $(evt.currentTarget);
            // Router.route(el.attr('href'), {"title": el.attr('title')})
            this.hide();
            NavButton.reset();
        })
    },

    click(li) {
        const id = li.attr('id');
        const dropdown = li.find('> .dropdown');
        const level = parseInt(dropdown.attr('level'));

        this.newLevel = {number: level, id: id, li: li, dropdown: dropdown};
        this.currentLevel = this.levels[level];
        this.levels[level] = this.newLevel;
        this.lastLevel = this.levels[this.levels.length - 1];

        this.container.attr('level', level);
        this.el.attr('theme', this.getTheme(level));

        if (this.currentLevel === undefined) {
            this.open();
            return;
        }

        if (this.currentLevel.number === this.newLevel.number) {
            if (this.currentLevel.id === this.newLevel.id) return;
            this.replace();
        }

        if (this.currentLevel.number < this.lastLevel.number) {
            this.close(this.lastLevel);
        }
    },

    open() {
        this.newLevel.li.addClass('selected');
        this.newLevel.dropdown.addClass('open');
        const shift = this.isMobile ? '0%' : '-100%';

        gsap.fromTo(this.newLevel.dropdown, {
                x: shift, display: 'none'
            }, {
                x: '0%', display: 'flex', duration: 0.5, overwrite: true
            }
        );

        this.setHeight(this.newLevel.dropdown.outerHeight());
    },

    replace() {
        this.currentLevel.li.removeClass('selected');
        gsap.set(this.currentLevel.dropdown, {zIndex: 10})
        gsap.set(this.currentLevel.dropdown.find('li'), {opacity: 0})

        gsap.set(this.newLevel.dropdown, {display: 'flex', opacity: 0, zIndex: 20})
        gsap.to(this.newLevel.dropdown, {
                opacity: 1, duration: 0.3, overwrite: true,
                onComplete: () => {
                    this.newLevel.dropdown.css({zIndex: ''});
                    this.currentLevel.dropdown.removeClass('open').removeAttr('style');
                    this.currentLevel.dropdown.find('li').removeAttr('style');
                    this.currentLevel.li.removeClass('selected');
                }
            }
        );

        this.newLevel.li.addClass('selected');
        this.newLevel.dropdown.addClass('open');
        this.setHeight(this.newLevel.dropdown.outerHeight());
    },

    close(level) {
        level.li.removeClass('selected');
        level.dropdown.removeClass('open');
        const shift = this.isMobile ? '0%' : '-100%';

        gsap.fromTo(level.dropdown, {
                x: '0%', display: 'flex'
            }, {
                x: shift, display: 'none', duration: 0.5, overwrite: true, clearProps: true,
            }
        );

        this.levels.splice(-1);
        this.lastLevel = this.levels[this.levels.length - 1];
        this.container.attr('level', this.lastLevel.number);
        this.el.attr('theme', this.getTheme(this.lastLevel.number));
        const height = this.lastLevel.dropdown ? this.lastLevel.dropdown.outerHeight() : 'auto';
        this.setHeight(height);
    },

    setHeight(height) {
        gsap.to(this.container.find('nav'), {height: height});
    },

    closeFrom(level) {
        const diff = this.lastLevel.number - this.levels[level].number + 1;
        const last = this.lastLevel.number;

        for (let i = 0; i < diff; i++) {
            setTimeout(() => {
                this.close(this.levels[last - i]);
            }, 200 * i)
        }
    },

    reset() {
        this.levels.forEach((el, i) => {
            if (el.number === 0) return;
            el.li.removeClass('selected');
            el.dropdown.removeClass('open');
            gsap.set(el.dropdown, {display: 'none'})
        })

        this.levels.splice(1);
        this.container.attr('level', 0);
        this.el.attr('theme', this.getTheme(0));
    },

    getTheme(level) {
        if (level > 0 && this.isMobile) this.icons.removeClass('inverse');
        else this.icons.addClass('inverse');

        switch (level) {
            case 0:
                return '';
            case 1:
                return 'marble';
            default:
                return 'white';
        }
    },

    show() {
        this.el.addClass('open');
        if (window.innerWidth < 1000)
            $('body').css({'overflow': 'hidden'});
    },

    hide() {
        if (window.innerWidth < 1000)
            $('body').css('overflow', '');

        if (this.isMobile) {
            this.el.removeClass('open');
            setTimeout(() => {
                this.reset();
                this.container.attr('level', 0);
                this.el.attr('theme', this.getTheme(0));
            }, 500)

        } else {
            if (this.levels.length > 1) {
                this.closeFrom(1);
                setTimeout(() => {
                    this.el.removeClass('open');
                }, 500)
            } else {
                this.el.removeClass('open');
            }
        }
    },

    resize: function () {
        this.isMobile = window.innerWidth < 1000;
    },

    getConfig(width) {
        let config = null;
        this.responsive.forEach((el, i) => {
            console.log(el);
            console.log(width > el.from);
            console.log(width <= el.to);
            if (width > el.from && width <= el.to) {
                console.log('> ', el.label)
                config = el;
                return el;
            }
        })

        console.log('---- ', config)
    },

    showBackButton() {
        this.el.addClass('back');
        this.logo.addClass('scrolled_permanent');
        this.el.find('.button.back').click((evt) => {
            evt.preventDefault();
            Router.back();
        })
    },

    setBackButton(backUrl) {
        console.log(backUrl)
        this.el.addClass('back');
        this.el.find('.button.back').click((evt) => {
            evt.preventDefault();
            Router.route(backUrl);
        })
    }
}

export default NavigationMain;
window.NavigationMain = NavigationMain;